module.exports = __webpack_public_path__ + "img/3.181238d3.png";